import { render, staticRenderFns } from "./SetPointDetection.vue?vue&type=template&id=6523746a&scoped=true&"
import script from "./SetPointDetection.script.js?vue&type=script&lang=js&"
export * from "./SetPointDetection.script.js?vue&type=script&lang=js&"
import style0 from "./SetPointDetection.scss?vue&type=style&index=0&id=6523746a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6523746a",
  null
  
)

export default component.exports